import React, { useEffect, useState } from "react";
import '../calendar.css';

interface CounterProps {
    value: number;
    max: number;
    min: number;
    setValue: (value: number) => void;
    vertical?: boolean;
    textable?: boolean;
}

const Counter = ({ value, max, min, setValue, vertical = false, textable = false }: CounterProps) => {
    const [count, setCount] = useState(value);

    useEffect(() => {
        setValue(count)
    }, [count])
    useEffect(() => {
        setCount(value)
    }, [value])

    if (min == null) min = 0;
    if (max == null) max = 100;
    if (min >= max) {
        console.error('min and max inversed in counter');
        let tpm = min;
        min = max;
        max = tpm;
    }

    const handleClick = (event: any) => {
        switch (event.target.id) {
            case 'incr-button': return incrementValue();
            case 'decr-button': return decrementValue();
        }
    }
    const handleValueChange = (event: any) => {
        let value = parseInt(event.target.value)
        if (value <= max && value >= min)
            setCount(value);

        else if (event.nativeEvent.data == null && (count < 10 && count > -10)) 
            setCount(0);

        event.target.value = count
    }

    const incrementValue = (): void => {
        let new_val = count + 1;
        if (new_val > max) return;

        setCount(new_val);
    }

    const decrementValue = (): void => {
        let new_val = count - 1;
        if (new_val < min) return;

        setCount(new_val);
    }

    return (vertical ?
        <div id="counter" className="px-1 m-px py-px text-center rounded-sm ">
            <div className="relative h-full w-14 raw-flex justify-between bg-white/70 rounded divide-y divide-gray-300">
                <button type='button' id="incr-button" className="w-2/3 hover:bg-gray-200/90 rounded-b" onClick={handleClick}> + </button>

                {textable ?
                    <input className="w-1/3 input-none text-center" type="number" id="input-counter" value={count} onChange={handleValueChange}/> :
                    <div className="w-2/3 place-self-center"> {count} </div>
                }

                <div className="w-2/3 place-self-center"> {count} </div>
                <button type='button' id="decr-button" className="w-2/3 hover:bg-gray-200/90 rounded-t" onClick={handleClick}> - </button>
            </div>
        </div>
        :
        <div id="counter" className="px-1 m-px py-px text-center rounded-sm ">
            <div className="relative h-full w-14 flex justify-between bg-white/70 rounded divide-x divide-gray-300">
                <button type='button' id="decr-button" className="w-1/3 hover:bg-white/90 rounded-l" onClick={handleClick}> - </button>

                {textable ?
                    <input className="w-1/3 input-none text-center" type="number" id="input-counter" value={count} onChange={handleValueChange}/> :
                    <div className="w-1/3"> {count} </div>
                }

                <button type='button' id="incr-button" className="w-1/3 hover:bg-white/90 rounded-r" onClick={handleClick}> + </button>
            </div>
        </div>
    );
}

export default Counter;